import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {
  discussionTypes: null,
}

let updateCommentCall = null
let addCommentCall = null
let deleteCommentCall = null

const getters = {
  discussionTypes() {
    return axios.get('/Discussion/Types')
  },
  async getMxRecDiscussions({ issueId, discussionTypes }) {
    const discussionCalls = discussionTypes.map(discussionId => {
      return axios
        .get(`/Discussion?issueId=${issueId}&discussionTypeId=${discussionId}`)
        .then(res => {
          return {
            discussionTypeId: discussionId,
            discussionData: res.data,
          }
        })
        .catch(() => {
          const errorType = discussionId === 1 ? 'investigation' : 'maintenance'
          return `${errorType} discussion`
        })
    })
    return axios.all(discussionCalls)
  },
  maintenanceDiscussion({ issueId, discussionTypeId }) {
    return axios.get(
      `/Discussion?issueId=${issueId}&discussionTypeId=${discussionTypeId}`,
    )
  },
  taggableUsers({ issueId }) {
    return axios.get(`/Discussion/TaggableUsers?maintenanceIssueId=${issueId}`)
  },
}

const saves = {
  updateComment({ comment, action }) {
    if (action === 'update') {
      updateCommentCall = axios.CancelToken.source()
      return axios
        .put(`/Discussion/${comment.id}`, comment, {
          cancelToken: updateCommentCall.token,
        })
        .catch(error => error)
    } else if (action === 'new') {
      addCommentCall = axios.CancelToken.source()
      return axios
        .post(`/Discussion/`, comment, {
          cancelToken: addCommentCall.token,
        })
        .catch(error => error)
    }
  },
  deleteComment(whichComment) {
    deleteCommentCall = axios.CancelToken.source()
    return axios
      .delete(`/Discussion?discussionId=${whichComment.discussionId}`, {
        cancelToken: deleteCommentCall.token,
      })
      .catch(error => error)
  },
}

export default class DiscussionService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }
}
